/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import RowDisplay from '../common/RowDisplay';
import { get } from 'lodash';
import ConsentFinalized from './components/ConsentFinalized';
import { consentIsPendingOrUnsent, getConsentStatusDisplay } from './utils';
import './stylesheets/informedConsent.scss';
import enums from '../../constants/enums';
function InformedConsent(props) {
  var contact = props.contact;
  var consentContactEnums = enums.consent.contact_status;
  var displayText = getConsentStatusDisplay(get(contact, 'consent.state'), consentContactEnums);
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-header"
  }, "Informed Consent"), /*#__PURE__*/React.createElement(RowDisplay, {
    label: "Consent Status",
    hideEdit: true
  }, consentIsPendingOrUnsent(contact) ? /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "profile-value"
  }, displayText)))) : /*#__PURE__*/React.createElement(ConsentFinalized, {
    contact: contact,
    consentContactEnums: consentContactEnums
  }))));
}
InformedConsent.propTypes = {
  contact: PropTypes.object.isRequired
};
export default InformedConsent;
//# sourceMappingURL=index.js.map